// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1uK7v","select":"Header_select__SEuBT","clinic":"Header_clinic__2CEwg"};